import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { Menu } from 'antd';
import PropTypes from 'prop-types';

const VariableMentionList = forwardRef(({
  items,
  command,
}, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index) => {
    const item = items[index];

    if (item) {
      command({ id: item.id, label: item.label, ...item });
    }
  };

  const upHandler = () => {
    setSelectedIndex((selectedIndex + items.length - 1) % items.length);
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <Menu
      className="variable-mention-list"
      style={{
        maxHeight: '300px',
        overflow: 'auto',
        paddingTop: 0,
        minWidth: '400px',
        maxWidth: '600px',
      }}
      selectedKeys={selectedIndex === null ? [] : [items[selectedIndex]?.id]}
    >
      {items.length ? (
        items.map((item, index) => (
          <Menu.Item
            key={item.id}
            onClick={() => selectItem(index)}
            style={{
              backgroundColor: index === selectedIndex ? '#f0f0f0' : 'transparent',
            }}
          >
            {item.label}
          </Menu.Item>
        ))
      ) : (
        <Menu.Item disabled>No results</Menu.Item>
      )}
    </Menu>
  );
});

/* eslint-disable react/forbid-prop-types */
VariableMentionList.propTypes = {
  items: PropTypes.array.isRequired,
  command: PropTypes.func.isRequired,
};

export default VariableMentionList;
